import axiosHttp from "services/axiosHttp";

// Purchase Order Service Functions
export const poService = {
  // Create PO
  createPO: async (data) => {
    const response = await axiosHttp.post("/pmo/po", data);
    return response.data;
  },

  // Get PO list with optional params
  getPOList: async (params = {}) => {
    const response = await axiosHttp.get("/pmo/po", { params });
    return response.data;
  },

  // Get single PO by ID
  getPO: async (id) => {
    const response = await axiosHttp.get(`/pmo/po/${id}`);
    return response.data;
  },

  // Update PO
  updatePO: async (id, data) => {
    const response = await axiosHttp.put(`/pmo/po/${id}`, data);
    return response.data;
  },

  // Delete PO
  deletePO: async (id) => {
    const response = await axiosHttp.delete(`/pmo/po/${id}`);
    return response.data;
  },
};

